import { combineReducers } from 'redux';
import estimationConfigReducer, {
	type Action as EstimationAction,
} from './estimation-config/reducer';
import sprintsReducer, { type Action as SprintsAction } from './sprints/reducer';
import timeTrackingOptionsReducer, {
	type Action as TimeTrackingOptionsAction,
} from './time-tracking-options/reducer';

export type Action = EstimationAction | SprintsAction | TimeTrackingOptionsAction;

export default combineReducers({
	estimationConfig: estimationConfigReducer,
	sprints: sprintsReducer,
	timeTrackingOptions: timeTrackingOptionsReducer,
});
